
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Comment combiner SEO et SEA pour des résultats imbattables",
    description:
      "Découvrez comment le SEO et le SEA peuvent collaborer pour maximiser votre visibilité en ligne. Apprenez à combiner ces deux stratégies pour des résultats optimaux.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
